(() => {
  const revealGuide = () => {
    const id = window.location.hash.slice(1);
    if (!id) return;
    const anchor = document.getElementById(id);
    const panel = anchor?.closest('details.ixr-guide');
    if (panel) panel.open = true;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;
    const target = new URL(link.href, window.location.href);
    if (target.pathname !== window.location.pathname) return;
    const anchor = document.getElementById(target.hash.slice(1));
    const panel = anchor?.closest('details.ixr-guide');
    if (panel) panel.open = true;
  });
  window.addEventListener('hashchange', revealGuide);
  document.addEventListener('shopify:section:load', revealGuide);
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('details.ixr-guide');
    if (panel) panel.open = true;
  });
  revealGuide();
})();
